module.exports = __webpack_public_path__ + "static/img/player-bg.f412d651.png";